<template>
  <div class="container py-5 mx-auto md-layout">
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <a href="/legal/privacy">&larr; Back to Privacy Portal</a>
    </div>
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <div class="md-layout-item md-size-100">
        <h1>Pixel Partners</h1>
        <p>
          When a user visits an ArtistHub website, we may send user data to our
          pixel partners on behalf of ourselves and our users. The OPT-OUT
          button available on our
          <a href="/legal/privacy">Privacy Portal</a> will cease data collection
          by these third party pixel partners.
        </p>
        <ul>
          <li>Facebook</li>
          <li>Google</li>
          <li>Google Tag Manager</li>
          <li>Snapchat</li>
          <li>Twitter</li>
          <li>TikTok</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
